import React from 'react'

import { formField } from 'decorators'

import AutoComplete from './AutoComplete'

export default formField(props => <AutoComplete {...props} />)
